module.exports = __webpack_public_path__ + "img/jfsc-table@2x.7055a70a.png";